module.exports = __webpack_public_path__ + "ptc_nakagawa_Q1.515843ee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/nakagawa/parent_to_child/ptc_nakagawa_Q1.jpg
// module id = efbr
// module chunks = 0